import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useState } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import './App.css'

import Loading from './three/Loading/Loading'
import Home from './components/Home/Home'
import Project from './components/Projects/Project'
import Projects from './components/Projects/Projects'
import About from './components/About/About'
import Contact from './components/Contact/Contact'

function App() 
{
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false)
  const [enableControls, setEnableControls] = useState(false)
  const [data] = useState([
    {
      title: "Retail Web Design",
      sub: "Design for an online shop selling sneakers. Scroll-based animations and a 3D view of the sneakers are the main points of the design.",
      desc: "A landing page for a shoe retail shop! The project features a 3D model of a shoe that users can interact with, providing a dynamic and engaging user experience.",
      technologies: 'React, React-Three, Three.js',
      date: '2022',
      url: 'retail',
      id: 1
    },
    {
      title: "Website owners platform",
      sub: "Web application for connecting website owners across the globe",
      desc: "Ongoing project for a web application. The platform aims to connect website owners across the globe creating a niche community. I've been responsible for building the application from scratch including design, frontend & backend.",
      technologies: 'React, Node, Express, MongoDB',
      date: 'Ongoing',
      url: 'owners',
      id: 2
    },
    {
      title: "Anila",
      sub: "Portfolio for activist Anila Kila",
      desc: `A portfolio website that showcases their creative work using stunning visual effects and shaders.
      The website features a dynamic and engaging user experience that allows visitors to explore the client's work through an interactive 3D environment. The project uses Three.js shaders to create stunning visual effects and animations, providing a unique and memorable experience for visitors.`,
      technologies: 'React, React-Three, Three.js',
      date: '2021',
      url: 'anila',
      id: 3
    },
    {
      title: "AI Facts",
      sub: "Portfolio for activist Anila Kila",
      desc: `Unique and engaging way to explore history through a 3D map. Users can search for any location and receive AI-generated suggestions of historical facts, providing them with a rich understanding of the area's past.`,
      technologies: 'React, React-three, Mapbox, OpenAi',
      date: '2023',
      url: 'map',
      id: 4
    },
    {
      title: "3D Customizer",
      sub: "Customizer for a car model",
      desc: `The project enables users to view and customize a virtual bike in 3D, choosing from a range of bike styles and customizing various parts of the bike.
      Users can view the bike from all angles, rotating and zooming in to get a closer look. They can select specific parts of the bike, such as the frame, handlebars, seat, and wheels, and change the colors of each part. The changes are displayed in real-time, providing users with immediate feedback.
      One of the key features of the project is its ease of use. The interface is intuitive and user-friendly, making it easy for users to customize the bike to their liking.`,
      technologies: 'React, React-Three, Three.js',
      date: '2022',
      url: '3d-customizer',
      id: 5
    },
    {
      title: "JUUBIX",
      sub: "Mini game",
      desc: "JUUBIX supplies ‘Stakeholders as a Service’ (SaaS) by providing a new collaborative marketplace for talent, companies, and investors. I've been part of team of young talented developers, working on the fronted for the game section of the company. ",
      technologies: 'React',
      date: 'Ongoing',
      url: 'juubix',
      id: 6
    },
    {
      title: "Stockbet",
      sub: "Betting tips website",
      desc: `A web app that provides users with football betting tips through a subscription-based model. The project features a comprehensive database of football matches and betting odds, and provides users with recommended bets based on analysis and predictions posted by the admin users.
      The web app is built using the MERN stack, which comprises MongoDB, Express.js, React, and Node.js. This technology stack provides a robust and scalable solution for building modern web applications.`,
      technologies: 'React, Node, Express, MongoDB',
      date: 'Ongoing',
      url: 'stockbet',
      id: 7
    },
    {
      title: "Groundrock",
      sub: "Website for website",
      desc: `A portfolio website for a marketing company that leverages Three.js to create stunning 3D visual effects and animations. The website provides an engaging and interactive user experience that showcases the company's marketing services and capabilities.`,
      technologies: 'Three.js',
      date: '2020',
      url: 'groundrock',
      id: 8
    }
  ])

  return (
    <HelmetProvider>
    <div className="App">
      <Loading />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home 
                                    sidebarIsOpen={sidebarIsOpen} 
                                    setSidebarIsOpen={setSidebarIsOpen} 
                                    setEnableControls={setEnableControls} 
                                    enableControls={enableControls}
                                  />} 

          />
          <Route path='/projects' element={<Projects sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} data={data} />} />
          <Route path="/projects/:id" element={<Project data={data} sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />} />
          <Route path='/about' element={<About sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />} />
          <Route path='/contact' element={<Contact sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />} />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  )
}

export default App
